import {Component, OnInit} from '@angular/core';

import {NetworkHelperService} from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, PAGE, GENERALES} from '../../../_config/strings';
import { Router } from '@angular/router';

import Swal from 'sweetalert2';
import {Usuario} from '../../../_model/Usuario';
import {Subject} from 'rxjs/Subject';

@Component({
    selector: 'app-listar-clientes',
    templateUrl: './listar-clientes.component.html',
    styleUrls: ['./listar-clientes.component.scss']
})

export class ListarClientesComponent implements OnInit {

    dtOptions: DataTables.Settings = {};
    dtTrigger: Subject<any> = new Subject();

    audio;
    FORMS: any;
    API: any;
    CODFUNC: any;
    PAGE: any;
    GENERALES: any;
    tipoDeCliente = '';
    // Permisos en botón
    botonesPermisos = {
        crearClie: false,
    };
    // Fin Permisos en botón
    public usuario: Usuario = new Usuario();
    clientesArray = [];
    clientesArrayReverse = [];

    permisosArray = [];

    constructor(
       // private chat: ChatService,
        private network: NetworkHelperService,
        private router: Router,
    ) {
        this.FORMS = FORMS;
        this.API = API;
        this.CODFUNC = CODFUNC;
        this.GENERALES = GENERALES;
        this.PAGE = PAGE;
        this.usuario = JSON.parse(localStorage.getItem('usuario'));
    }

    ngOnInit() {
        this.dtOptions = {
            language: {
                url: '//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json'
            },
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;
                // Unbind first in order to avoid any duplicate handler
                // (see https://github.com/l-lin/angular-datatables/issues/87)
                $('td', row).unbind('click');
                $('td', row).bind('click', () => {
                    this.selectedRowCliente(data);
                });
                return row;
            }
        };
        this.getPermisos();
        this.getClientes();
        this.inverse();
    }

    getClientes() {
        this.network.callSecureService(
            this.API.user.sucursales + '/' + this.usuario.sucId + '/' + this.API.user.clientes,
            'GET',
            null)
            .subscribe((response: any) => {
                    console.log(response);
                    const responseMensaje = response.Mensaje.reverse();
                    let incremento = 1;
                    for (const clienteResponse of responseMensaje) {
                        // Prueba
                        this.tipoDeCliente = clienteResponse.tipoCliente;
                        /*
                        if ( this.tipoDeCliente === 'ESPECIAL') {
                            this.tipoDeCliente = clienteResponse.razonSocial !== '' || clienteResponse.razonSocial == null ? 'C.E.: ' + clienteResponse.razonSocial : 'C.E.: ' + clienteResponse.nombre + ' ' + clienteResponse.paterno + ' ' + clienteResponse.materno;
                        } else {
                            this.tipoDeCliente = clienteResponse.razonSocial !== '' || clienteResponse.razonSocial == null ? clienteResponse.razonSocial : clienteResponse.nombre + ' ' + clienteResponse.paterno + ' ' + clienteResponse.materno;
                        }
                        */
                       // console.log(clienteResponse.nombre);
                       let tipoCliente;
                       clienteResponse.razonSocial !== '' || clienteResponse.razonSocial == null ? tipoCliente = clienteResponse.razonSocial : tipoCliente = clienteResponse.nombre + ' ' + clienteResponse.paterno + ' ' + clienteResponse.materno;
                        // Prueba
                        if ( this.tipoDeCliente !== 'ADMINPAQ' ) {
                            this.clientesArray.push({
                                id: incremento++,
                                idCliente: clienteResponse.id,
                                // tipoCliente: this.tipoDeCliente,
                                clienteEMF: this.tipoDeCliente,
                                tipoCliente: tipoCliente,
                                rfc: clienteResponse.rfc,
                                email: clienteResponse.email,
                                telefono: clienteResponse.telefono,
                                estatusNombre: clienteResponse.estatus.nombre,
                                estatusColor: clienteResponse.estatus.color,
                                sucursal: clienteResponse.sucursalNombre,
                                atendido: clienteResponse.creadoPor,
                                fechaCreacionDia: clienteResponse.fechaCreacion.split('T')[0],
                                // fechaCreacionHora: clienteResponse.fechaCreacion.split('-')[2]
                            });
                        }
                    }
                    console.log( this.clientesArray );
                this.dtTrigger.next();
            }, err => {
                console.log(err);
                Swal('Error', this.GENERALES.algoOcurrio, 'error');
            }
        );
    }

    inverse() {
        this.clientesArrayReverse = this.clientesArray.reverse();
    }

    getPermisos() {
        const peticion = {
            userId: this.usuario.userId,
            codigoFuncionalidad: 'CLIVER'
        };

        this.network.callSecureService(
            this.API.user.permisosFuncionalidad,
            'POST',
            peticion)
            .subscribe((response: any) => {
                    this.permisosArray = response.Mensaje;
                    this.mostrarBotones();
                }, err => {
                    console.log(err);
                    Swal('Error', this.GENERALES.algoOcurrio, 'error');
                    this.mostrarBotones();
                }
            );
    }

    selectedRowCliente (info: any) {
        // console.log(this.permisosArray.length);
        const permisoVerCliente = this.permisosArray.find( permiso => permiso === 'CLIVER' );
        if (permisoVerCliente) {
            this.router.navigate(['dashboard/verCliente/', info ]);
            // info[1]
        } else {
            Swal('Error', this.GENERALES.noTienePermisos, 'error');
        }
        /*
        let editarBtn = '';
        let verBtn = '';
        let borrarBtn = '';

        for (const permiso of this.permisosArray) {
            if ( permiso === 'CLIVER' ) {
                editarBtn = '<button (click)="navegar()" type="button" class="ml-3 btn waves-effect waves-light btn-info">' +
                    this.GENERALES.ver + '</button>';
            } else if (permiso === 'CLIEDIT') {
               //verBtn = '<button type="button" class="ml-3 btn waves-effect waves-light btn-success">' +
                 //   this.GENERALES.editar + '</button>';
            } else if ( permiso === 'CLIELIM' ) {
                //borrarBtn = '<button type="button" class="ml-3 btn waves-effect waves-light btn-danger">' +
                  //  this.GENERALES.borrar + '</button>';
            }
        }
        */
    }

    clienteSeleccionado (id: any) {
        this.selectedRowCliente(id);
    }

    mostrarBotones () {
        const permisoCrearCliente = this.permisosArray.find( permiso => permiso === 'CLICREA' );
        if (permisoCrearCliente) {
            this.botonesPermisos.crearClie = true;
            document.getElementById('botonCrearCliente').style.opacity = '1';
        } else {
            // Swal('Error', this.GENERALES.noTienePermisos, 'error');
            // this.router.navigate(['/dashboard']);
        }
    }

} // class



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/cliente/listar-clientes/listar-clientes.component.ts